var _defs, _path, _g, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStripline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "STRIPLINE",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      #STRIPLINE .cls-1 {\n        fill: #a771ff;\n      }\n\n      #STRIPLINE .cls-2 {\n        fill: #f5f5f5;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_121",
    "data-name": "Pfad 121",
    className: "cls-1",
    d: "M16,2A14,14,0,1,1,2,16,14.041,14.041,0,0,1,16,2m0-2A16,16,0,1,0,32,16,15.983,15.983,0,0,0,16,0Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_51",
    "data-name": "Gruppe 51"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_122",
    "data-name": "Pfad 122",
    className: "cls-2",
    d: "M24.9,8.9v3H21.7v2.5H20.4V11.9H11.7v2.5H10.4V11.9H7v-3H24.9m1-1H6v5H9.2v2.5h3.3V12.9h6.7v2.5h3.3V12.9h3.2v-5Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_123",
    "data-name": "Pfad 123",
    className: "cls-2",
    d: "M23.7,22.4a2.8,2.8,0,1,1-5.6,0c0-1.5,2.8-5.5,2.8-5.5S23.7,20.8,23.7,22.4Zm-1.5-.9a.7.7,0,1,0,.7.7A.751.751,0,0,0,22.2,21.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_124",
    "data-name": "Pfad 124",
    className: "cls-2",
    d: "M13.7,22.4a2.8,2.8,0,0,1-2.8,2.8,2.734,2.734,0,0,1-2.8-2.8c0-1.5,2.8-5.5,2.8-5.5S13.7,20.8,13.7,22.4Zm-1.6-.9a.7.7,0,1,0,.7.7A.684.684,0,0,0,12.1,21.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStripline);
export default __webpack_public_path__ + "static/media/stripline.03a9af67420274db3854822281f63160.svg";
export { ForwardRef as ReactComponent };